export const compliance_urls = {
  ComplianceRulesLandingPage: "/compliance-rules-engine/:country",
};

export const DATE_RANGE_SIZE = 2;

export default {DATE_RANGE_SIZE};
